module.exports = __webpack_public_path__ + "img/th.8950a114.png";